import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.00774 21.0014H2V14.9956L7.00774 9.979V21.0014Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 21.0065H16.9923V9.91893L22 4.00193V21.0065Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.51717 3.99316L2.99447 3.99318L12.8191 13.2574L16.1576 9.91893L9.51717 3.99316Z"}}]};

const LogoXiaomareportFilled = Vue.extend<IconProps>({
  name: 'LogoXiaomareportFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-xiaomareport-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoXiaomareportFilled;
